export interface IQuestion {
  title: string
  answer: string
}

export const defaultQuestions: IQuestion[] = [
  {
    title: 'how_crypto_loans_work_title',
    answer: 'how_crypto_loans_work_text',
  },
  {
    title: 'how_to_repay_crypto_loan_title',
    answer: 'how_to_repay_crypto_loan_text',
  },
  {
    title: 'why_bitcoin_loan_title',
    answer: 'why_bitcoin_loan_text',
  },
  {
    title: 'borrow_against_xrp_title',
    answer: 'borrow_against_xrp_text',
  },
  {
    title: 'interest_rate_options_title',
    answer: 'interest_rate_options_text',
  },
  {
    title: 'instant_crypto_loan_title',
    answer: 'instant_crypto_loan_text',
  },
  {
    title: 'collateral_value_changes_title',
    answer: 'collateral_value_changes_text',
  },
  {
    title: 'crypto_lending_api_title',
    answer: 'crypto_lending_api_text',
  },
  {
    title: 'crypto_loan_app_title',
    answer: 'crypto_loan_app_text',
  },
  {
    title: 'fixed_term_loans_faq_title',
    answer: 'fixed_term_loans_text',
  },
  {
    title: 'are_crypto_loans_worth_it_title',
    answer: 'are_crypto_loans_worth_it_text',
  },
]